module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"closedToday":"Heute geschlossen","noEntries":"Noch keine Einträge vorhanden.","noResults":"Keine Treffer für „{search}“.","openToday":"Heute geöffnet","other":"Sonstige","search":"Suche"},"en":{"closedToday":"Closed today","noEntries":"No entries yet.","noResults":"No results for “{search}”.","openToday":"Open today","other":"Other","search":"Search"}}')
  delete Component.options._Ctor
}
